module.exports = __webpack_public_path__ + "static/media/logo.b782c957.png";